type Props = {
  onClick?: () => void;
  id?: string;
  operation: string;
};

//  @function TriggerAdd
//  Renders a special trigger used to create new one
//  @param {function} onClick - function to be called whenever this component is clicked upon
//  @param {string} className - string appended to the already existing component's className
//  @param {string} id - ID used to identify this particular component
//  @returns {React.Node}
export default function TriggerAdd({ onClick, id, operation }: Props) {
  const colouring = {
    background: "#515151",
    colour: "#949494",
  };
  return (
    <div
      id={id}
      className="select-none cursor-pointer w-fit h-10 leading-10 px-6 text-2xl"
      style={{
        color: colouring.colour,
      }}
      onClick={onClick}
    >
      {operation}
    </div>
  );
}
